import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from 'react-helmet'
import { config } from 'config'

export default class Index extends React.Component {

  constructor() {
    super()
    this._rotateImage = this._rotateImage.bind(this)
    this.state = { index: 1, intervalId: 0 }
  }

  componentDidMount() {
    const intervalId = setInterval(this._rotateImage, 4000)
    this.setState({intervalId: intervalId})
  }
 
  componentWillUnmount() {
    clearInterval(this.state.intervalId)
  }

  _rotateImage() {
    const index = this.state.index
    if(index !== 5) 
      this.setState({ index: index + 1 })
    else
      this.setState({ index: 1 })
  }

  _drawImage() {
    const index = this.state.index
    return (  
      <div className='slides'>
        <img src='assets/home/home1.jpg' className={index === 1 ? 'show-slide' : '' } />
        <img src='assets/home/home2.jpg' className={index === 2 ? 'show-slide' : '' } />
        <img src='assets/home/home3.jpg' className={index === 3 ? 'show-slide' : '' } />
        <img src='assets/home/home4.jpg' className={index === 4 ? 'show-slide' : '' } />
        <img src='assets/home/home5.jpg' className={index === 5 ? 'show-slide' : '' } />
      </div> 
    )
  }

  render() {
    return (
      <div
        style={{
          height: 690,
          paddingTop: 75
        }}
      >
        
        { this._drawImage() }

        <div
          style={{
            position: 'relative',
            top: 444,
            padding: 10,
            border: '1px solid #cccccc',
            color: '#1b1b37',
            width: 120,
            fontSize: 12,
            lineHeight: '16px'
          }}
        >
          <Link className='link-alt' 
            to={prefixLink('/exhibitions/')}>Exhibitions</Link><br/>
          and Awards
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./index.js